import React, { useState, useRef, useContext, useEffect } from 'react';
import { LangCtx, PayLoadCtx ,InstavcCtx} from "../../../lib/context";
import "../Styles.css";
import "./doctorInvites.css";

import { getInvitees, createInvitee } from '../../../actions/schedule';
import { validateEmail, validateCharecters } from '../../../lib/validation';
import NoData from "../../../lib/ui/nodata/NoData";
import Loader from "../../../lib/ui/loader/Loader";
import DoctorInviteForm from "./docInviteForm";
import DoctorInvitesList from "./docInvitesList";
import useDebounce from "../../common/useDebounce";
import { toast } from 'react-toastify';

const DoctorInvites = (props) =>
{
    const { l } = useContext(LangCtx);
    const inviteeList = useRef(null);
    const [ loading, setLoading ] = useState(false);

    const errorMsg = '';
    const [ error, setError ] = useState({});
    // const searchRef = useRef(null);
    // const [ page, setPage ] = useState(0);
    const itemsPerPage = useRef(5);
    const [ count, setCount ] = useState(0);
    const [ searchTerm, setSearchTerm ] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const [ invitees, setInvitees ] = useState([]);
    const [ formData, setFormadata ] = useState({
        name: '',
        email: ''
    });
    const { payload } = useContext(PayLoadCtx);
    const appointments = useContext(InstavcCtx);
    let sub = localStorage.getItem('sub');
     console.log("qwertyuio",payload);
    const loadInvitees = (body) =>
    {
        setLoading(true);
        let query = `?sub=${sub}&appointmentId=${appointments?.appointmentData?.appointmentId}&limit=${itemsPerPage.current}`;

        if (searchTerm)
        {
            query += `&searchkey=${searchTerm}`;
        }

        getInvitees(query).then((res) => {
            setLoading(false);
            if (res && res?.status) {
                setFormadata({
                    name: '',
                    email: ''
                })
                setError({});
                setInvitees(res.data.getData);
                setCount(res.data.count);
            }
            else {
                setFormadata({
                    name: '',
                    email: ''
                })
                setError({});
                setInvitees([]);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            setError({});
            console.log("err in get invitees==== ", err);
        })
    };

    const handleChange = (name, value) =>
    {
        let _formaData = { ...formData };
        _formaData = {
            ..._formaData,
            [ name ]: value
        };
        setFormadata(_formaData);
    };

    const validateForm = () =>
    {
        let _error = {};
        let returnValue = true;

        if (formData.name === '' || formData.name == null)
        {
            _error[ 'name' ] = l.pls_ent_name;
            returnValue = false;
        } else if (!validateCharecters(formData.name) || formData.name.length < 3)
        {
            _error[ 'name' ] = l.pls_ent_three_ltrs_name;
            returnValue = false;
        }
        if (formData.email === '' || formData.email == null)
        {
            _error[ 'email' ] = l.pls_enter_email;
            returnValue = false;
        }
        else if (!validateEmail(formData.email))
        {
            _error[ 'email' ] = l.pls_check_email;
            returnValue = false;
        }
        else if (invitees.length > 0 && invitees.find((data) => data?.email === formData?.email.toLowerCase()))
        {
            _error[ 'email' ] = l.email_exs_alrdy;
            returnValue = false;
        }

        setError(_error);
        return returnValue;
    };

    const handleCreateInvitee = (e) =>
    {
        e.preventDefault();
        try
        {
            if (validateForm())
            {
                setLoading(true);
                let createData = {
                    name: formData.name,
                    email: formData.email.toLowerCase()
                };

                createInvitee(createData, payload.userId).then(res =>
                {
                    setLoading(false);
                    if (res.status)
                    {
                        toast.success(l.invite_crt_succ, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        loadInvitees();
                    }
                }).catch(err =>
                {
                    setLoading(false);
                    toast.error(err?.response?.data?.error, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    // setErrorMsg(l.unable_crt_invite)
                });
            }
        } catch (e)
        {
            setLoading(false);
            console.log("Error", e);

            // setErrorMsg(l.went_worng_pls_try_again)
        }
    };

    useEffect(() =>
    {
        // if (searchRef.current !== searchTerm)
        // {
        //     searchRef.current = searchTerm;
        //     if (query.includes('LastEvaluatedKey'))
        //     {
        //         query = `?sub=${sub}&limit=${itemsPerPage.current}&searchkey=${searchTerm}`;
        //     }
        itemsPerPage.current=5
            loadInvitees();
        // }
    }, [ debouncedSearchTerm ]);

    // const handleSerach = (e) => {
    //     setSearchTerm(e.target.value)
    //     let val = e.target.value.trim();
    //     if (val.length > 1 || val.length === 0) {
    //         let filter = val.toUpperCase();
    //         let li = inviteeList.current.getElementsByClassName('listAutoUL');
    //       //  let li = parent.getElementsByClassName('listAutoContent');
    //         for (let i = 0; i < li.length; i++) {
    //             let a = li[i].getElementsByClassName("listAutoContent")[0];
    //             if (a) {
    //                 let txtValue = a.textContent || a.innerText;
    //                 if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                     console.log('list display---------');
    //                     li[i].style.display = "";
    //                 } else {
    //                     li[i].style.display = "none";
    //                     console.log('list display none');
    //                 }
    //             }
    //         }
    //     }
    // }

    const handleLoadMore = () =>
    {
        if (count>invitees.length)
        {
            itemsPerPage.current=itemsPerPage.current+5
            loadInvitees();
        }
    };

    return (
        <div className="baseContainer">
            {loading && <Loader />}
            <div className="invHdngTopCol">
                <div className="inviteHdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.invite_hdng}</h2>
                </div>
                {errorMsg &&
                    <div className="errorBox">
                        <small className="errorTxt">{errorMsg}</small>
                    </div>
                }
                <DoctorInviteForm handleCreateInvitee={handleCreateInvitee} handleChange={handleChange} formData={formData} error={error} />
            </div>
            <div className="inviteListContainer">
                <div className="invListHdr">
                    <div className="inviteFormHdng">
                        <p className="invListHdng">{l.invite_contacts}</p>
                    </div>
                    <div className="emailSearchBlock">
                        <div className="searchBox searchFull">
                            <form method="post" className="searchForm" onSubmit={(e) => e.preventDefault()}>
                                <input className="textbox" title="Search" value={searchTerm} placeholder={l.search} type="text" onChange={(e) => setSearchTerm(e.target.value)} />
                            </form>
                        </div>
                    </div>
                </div>
                {/* <div className="inviteListBlock" ref={inviteeList}>
                    {loading ? <Loader /> : invitees.length > 0 ? invitees.map((invitee, i) => (
                        <DoctorInvitesList data={invitee} key={i} index={i} handleDelete={handeDelete} />
                    )) : <NoData Heading={l.no_invitees} src="/images/icons/invite-new.png" label='' />
                    }
                </div> */}
                {invitees && invitees?.length > 0 ?
                    <div className='inviteListBlock' ref={inviteeList}>
                        {
                            invitees?.map((item, i) => (
                                <DoctorInvitesList data={item} key={i} index={i} loadData={loadInvitees} />
                            ))
                        }

                        {(count!== invitees.length) &&
                            <div className='flexRow alignCenter justifyCenter mrgnTopXS'>
                                {/* <Button variant='contained' color='primary' onClick={handleLoadMore}>Load More</Button> */}
                                <button className="btnFilled sm ripple" onClick={handleLoadMore}>
                                    <span>Load More</span>
                                </button>
                            </div>}

                    </div> : !loading ? <NoData Heading={l.no_invitees} src="/images/icons/invite-new.png" label='' /> : ''
                }
            </div>
        </div>
    );
};
export default DoctorInvites;
